module.exports = __webpack_public_path__ + "static/media/chevron-green.fa26381c.svg";